
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { BaseCheckboxTextBoxComponent } from '../../controls/core/base/base-checkbox-text-box/base-checkbox-text-box.component';
import type { ZoomResultsColumnCellRendererParams } from '@nts/std/interfaces';
// create your cellEditor as a Angular component
@Component({
    imports: [
    BaseCheckboxTextBoxComponent
],
    template: `
        @if (this.params?.data) {
          <div  style="display: flex; height: 100%; align-items: center; justify-content: center;">
            <nts-base-checkbox-text-box
              (onClick)="onClick()"
              [isDisabled]="true"
              [checkStatus]="value">
            </nts-base-checkbox-text-box>
          </div>
        } @else {
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        }
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`

        nts-base-checkbox-text-box ::ng-deep .checkbox-wrapper:focus-within {
            outline: none;
            outline-color: unset;
            outline-width: 0;
            background-color: unset;
            border-radius: 0;
        }
    `]
})
export class ZoomResultsBoolCellRendererComponent implements AgRendererComponent {
    params: ZoomResultsColumnCellRendererParams;
    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ZoomResultsColumnCellRendererParams): void {
        this.params = params;
    }

    onClick() {
        this.params.node.setSelected(true, true);
    }

    get value() {
        return this.params.data[Number.parseInt(this.params.colDef.field, 10)];
    }
}
